<template>
  <a-card :bordered="false">
    <div class="bi-box">
      <div style="width: 240px;overflow: hidden;display: inline-block">
        <a-upload
          style="width: 200px;"
          :multiple="true"
          :action="uploadUrl"
          :showUploadList="false"
          :data="uploadData"
          listType="picture-card"
          @change="fileInfo=>handleChange(fileInfo,1)"
          :before-upload="handleBefore"
        >
          <img v-if="imageUrl" :src="imageUrl" alt="avatar"/>
          <div v-else class="upload-box">
            <img src="../../../assets/images/upload_icon.png">
            <div style="margin-top: 10px">拖拽或点击以导入批量添加文件</div>
          </div>
        </a-upload>
      </div>
      <a class="down-load-button" @click="downloadEvent">下载批量导入成员模板</a>
      <div v-if="loading" class="loading-box">
        <a-spin size="large"/>
      </div>
    </div>
  </a-card>
</template>

<script>
import formMixin from '../../../utils/mixins/formMixins'

export default {
  name: 'BatchImportComponent',
  mixins: [formMixin],
  data() {
    return {
      loading: false,
      imageUrl: '',
      uploadUrl: '',
      downloadUrl: '',
      uploadData: {}
    }
  },
  mounted() {
    this.uploadData = {
      token: this.$store.getters.token
    }
    this.uploadUrl = this.getAppConfig().userUrl + '/staff/v2/batchSaveStaff'
  },
  methods: {
    downloadEvent() {
      let downloadUrl = this.getAppConfig().userUrl + 'staff/v2/getBatchTemplate'
      window.open(downloadUrl)
    },
    handleChange(fileInfo, index) {
      if (fileInfo.file.status === 'uploading') {
        this.loading = true
      } else if (fileInfo.file.status === 'done') {
        this.loading = false
        if (fileInfo.file.response.status === 1) {//
          this.$message.success('导入成功')
          setTimeout(() => this.backEvent(), 500)
        } else if (fileInfo.file.response.msg) {
          this.$message.error(fileInfo.file.response.msg)
        } else {
          this.$message.error('导入失败，请重试')
        }
      }
    },
    handleBefore(file) {
      if (this.handleBeforeUploadExcelFile(file)) {
        return true
      }
      return false
    }
  }

}
</script>
<style lang="less">
.bi-box {
  position: relative;
  width: 100%;
  height: 300px;
  text-align: center;
  border: 1px dotted dodgerblue;
  background: #FAFAFA;

  .ant-upload .ant-upload-btn {
    background: transparent;
  }

  .ant-upload-list {
    max-width: 200px;
  }

  .upload-box {
    width: 200px;
    padding-top: 40px;
    text-align: center;
  }

  .down-load-button {
    position: absolute;
    bottom: 30px;
    right: 30px;
  }

  .ant-upload.ant-upload-select-picture-card {
    background-color: transparent;
    border: 1px none;
    width: 200px;
  }

  .picture-card .ant-upload-list-item {
    padding: 0;
  }

  .loading-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 300px;
  }
}

</style>